import apiAxios from './apiAxios';
import { handleResponse } from './handleResponse';

function getVersionCode(version: string) {
  const [major, minor, patch] = version.split('.');
  return +major * 1000000 + +minor * 10000 + +patch;
}

const BASE_TOKEN_ROUTE = '/api/push/business/tokens';

export const notificationsApi = {
  registerToken: async (token: string, version: string) => {
    return apiAxios
      .post(`${BASE_TOKEN_ROUTE}/register`, {
        agent: 'web',
        token,
        versionCode: getVersionCode(version),
      })
      .then(handleResponse);
  },
  unregisterToken: async (token: string) => {
    return apiAxios
      .post(`${BASE_TOKEN_ROUTE}/unregister`, { token })
      .then(handleResponse);
  },
};
